import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/planejadosdashboard",
    name: "PlanejadosDashboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/planejadoscontratos",
    name: "PlanejadosContratos",
    beforeEnter: routeGuard,
    component: () => import("../views/Contratos.vue"),
	},
	{
    path: "/planejadosconsumidores",
    name: "PlanejadosConsumidores",
    beforeEnter: routeGuard,
    component: () => import("../views/Consumidores.vue"),
  },
	{
    path: "/planejadosrealdashboard",
    name: "PlanejadosRealDashboard",
    beforeEnter: routeGuard,
    component: () => import("../views/RealDashboard.vue"),
  },
  {
    path: "/planejadoscontratosfrm",
    name: "PlanejadosContratosFrm",
    component: () => import("../views/ContratosFrm.vue"),
    beforeEnter: routeGuard,
    children: [
      {
        path: ":id",
        component: () => import("../views/ContratosFrm.vue"),
      }
    ]
	},
	{
    path: "/planejadosconsumidoresfrm",
    name: "PlanejadosConsumidoresFrm",
    beforeEnter: routeGuard,
    component: () => import("../views/ConsumidoresFrm.vue"),
    children: [
      {
        path: ":id",
        component: () => import("../views/ConsumidoresFrm.vue"),
      }
    ]
  },
    {
    path: "/planejadosromaneios",
    name: "PlanejadosRomaneios",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../../Transportadora/views/Romaneios.vue"),
  },
];
